//# sourceMappingURL=sitemap.mjs.map
/// <reference types="./sitemap.d.mts" />
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";

/**
 * An empty substring keeps every URL.
 */
export function filter(urls, substring) {
  if (substring === "") {
    return urls;
  } else {
    return $list.filter(
      urls,
      (_capture) => { return $string.contains(_capture, substring); },
    );
  }
}

function escape(value) {
  let _pipe = value;
  let _pipe$1 = $string.replace(_pipe, "&", "&amp;");
  let _pipe$2 = $string.replace(_pipe$1, "<", "&lt;");
  return $string.replace(_pipe$2, ">", "&gt;");
}

export function build_urlset_xml(urls) {
  let _block;
  let _pipe = urls;
  let _pipe$1 = $list.map(
    _pipe,
    (url) => { return ("<url><loc>" + escape(url)) + "</loc></url>"; },
  );
  _block = $string.join(_pipe$1, "");
  let entries = _block;
  return ("<?xml version=\"1.0\" encoding=\"UTF-8\"?><urlset xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\">" + entries) + "</urlset>";
}
